<template>
  <div v-if="status === 'loading'" class="p-4 text-center">
    <spinner />
  </div>
  <template v-if="status === 'error'">
    <slot name="error">
      <div>
        <Alert kind="danger">{{ error.message }}</Alert>
      </div>
    </slot>
  </template>
  <template v-if="status === 'success'">
    <slot></slot>
  </template>
</template>

<script setup lang="ts">
  import Spinner from '@/common/ui/components/Spinner.vue';
  import {computed} from 'vue';
  import normalizeError from '@console/helpers/normalizeError';
  import Alert from '@/common/ui/components/Alert.vue';

  const props = defineProps<{
    status: string;
    error?: any;
  }>();

  const error = computed(() => normalizeError(props.error));
</script>

<style scoped></style>
